import Delegate from 'ftdomdelegate';

export default () => {
  const pageTransitionElement = document.querySelector('.page-transition');

  if (pageTransitionElement) {
    Object.assign(pageTransitionElement.style, {
      opacity: 0,
      pointerEvents: 'none',
    });

    setTimeout(() => {
      // Prevent the theme editor from seeing this
      pageTransitionElement.style.visibility = 'hidden';
    }, 300);

    const delegate = new Delegate(document.body);

    delegate.on(
      'click',
      'a[href]:not([href^="#"]):not(.no-transition):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
      onLeave
    );

    window.onpageshow = function (e) {
      if (e.persisted) {
        Object.assign(pageTransitionElement.style, {
          opacity: 0,
          pointerEvents: 'none',
        });
      }
    };
  }

  function onLeave(evt, target) {
    evt.preventDefault();

    function transitionedOut(e) {
      if (e.propertyName === 'opacity') {
        pageTransitionElement.removeEventListener(
          'transitionend',
          transitionedOut
        );
        window.location.href = target.href;
      }
    }

    pageTransitionElement.addEventListener('transitionend', transitionedOut);

    Object.assign(pageTransitionElement.style, {
      opacity: 1,
      pointerEvents: 'all',
      visibility: 'visible',
    });
  }
};
